import * as yup from 'yup';

export const platformPracticeSchema = yup.object().shape({
  name: yup.string().required('common.fieldRequired'),
  id_code: yup.string().required('common.fieldRequired'),
  color_code: yup.string().required('common.fieldRequired'),
  state: yup.string().required('common.fieldRequired'),
  methodology_id: yup.string().required('common.fieldRequired')
});

export const platformPracticeEditSchema = platformPracticeSchema;
